import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/audit").then((r) => setItems(r.data?.items || r.data || [])); }, []);
  const filtered = items.filter((i) => !q || `${i.action} ${i.user_email} ${JSON.stringify(i.details)}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-end flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Denetim</div>
          <h1 className="font-display text-3xl font-bold mt-1">Denetim Kayıtları</h1>
        </div>
        <Input placeholder="Ara..." value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs" data-testid="audit-search" />
      </div>
      <Card>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-muted/50 text-xs uppercase tracking-wider text-muted-foreground">
                <tr><th className="text-left p-3">Tarih</th><th className="text-left p-3">Kullanıcı</th><th className="text-left p-3">İşlem</th><th className="text-left p-3">Detay</th></tr>
              </thead>
              <tbody>
                {filtered.map((i) => (
                  <tr key={i.id} className="border-t border-border">
                    <td className="p-3 whitespace-nowrap">{new Date(i.at).toLocaleString("tr-TR")}</td>
                    <td className="p-3">{i.user_email}</td>
                    <td className="p-3"><Badge variant="secondary">{i.action}</Badge></td>
                    <td className="p-3 text-xs text-muted-foreground">{JSON.stringify(i.details)}</td>
                  </tr>
                ))}
                {filtered.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-muted-foreground">Kayıt yok</td></tr>}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
